module.exports = __webpack_public_path__ + "img/quote.cca757a8.svg";